export default "__VITE_ASSET__Ck8Gb0eK__"